module.exports = __webpack_public_path__ + "img/hamburger-button-blue.948c2c43.svg";